<template>
    <img src="res/fhsy.png" :class="picposcls" class="iconsize" @click="$root.$emit('SwitchTo','P1')">
</template>

<script>

export default {
  data() {
    return {

    };
  },

  props:{
    picposcls:String,
  },

  mounted(){
    // window.console.log(this.picposcls);
  },

  methods: {

  },

  components: {}
};
</script>

<style lang="scss">

</style>
